export default __webpack_public_path__ + "static/media/stamp6.c0f30a4a.png";